export const BED_ISA_CODE = "BISA";
export const EXCLUDED_TYP_CODES = "AEMA,BUCD,BUYD,EEYA,IEEA,WDCR,AEFA,PFCC,PFDC";
